import { render, staticRenderFns } from "./MarketTable.html?vue&type=template&id=62b9e6ce&scoped=true&"
import script from "./MarketTable.js?vue&type=script&lang=js&"
export * from "./MarketTable.js?vue&type=script&lang=js&"
import style0 from "./market-table.scss?vue&type=style&index=0&id=62b9e6ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9e6ce",
  null
  
)

export default component.exports